<template>
    <v-dialog
        v-model="dialog"
        :persistent="!dismissible"
        max-width="500"

    >
        <v-card>
            <v-card-title>
                <h3 class="title">{{title}}</h3>
                <v-spacer></v-spacer>
                <v-icon size="18" v-if="dismissible" @click="hide">fas fa-times</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="content">
               <p v-html="content"></p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small depressed rounded :disabled="loading" @click.stop="onCancel">{{cancelLabel || 'Cancelar'}}</v-btn>
                <v-btn :loading="loading" small dark depressed rounded color="primary" @click.stop="onConfirm">{{confirmLabel || 'Confirmar'}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default{
        props: ['title', 'content', 'persistent', 'closeOnConfirm', 'loading', 'cancelLabel', 'confirmLabel'],
        data(){
            return {
                dialog: false
            }
        },
        computed:{
          dismissible(){
              var vm = this
              return !(vm.persistent === true)
          }
        },
        methods:{
            show(){
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            onConfirm(){
                this.$emit('confirm')
                if(this.closeOnConfirm !== false){
                    this.hide()
                }
            },
            onCancel(){
                this.$emit('cancel')
                if(this.closeOnCancel !== false){
                    this.hide()
                }
            }
        },
        watch:{
            dialog(newVal){
                this.$emit('change', newVal)
            }
        }
    }
</script>
